<template>
  <div>
    <sub-main/>
  </div>
</template>
<script>
import SubMain from '../clubdegolf/mapLocation/SubMain.vue'
export default {
  name: "SubMenu",
  components: {
    SubMain
  }
}
</script>
<style scoped>
</style>